import {
	API_GET_ALL_TUBE_REASON_UNTAKEN,
	API_GET_ALL_TUBE_REASON_UNTAKEN_SUCCESS,
	API_GET_ALL_TUBE_REASON_UNTAKEN_FAIL,
	API_GET_ALL_TUBE_REASON_ADDED,
	API_GET_ALL_TUBE_REASON_ADDED_SUCCESS,
	API_GET_ALL_TUBE_REASON_ADDED_FAIL,
	API_GET_ALL_TUBE_REASON_NATURE,
	API_GET_ALL_TUBE_REASON_NATURE_SUCCESS,
	API_GET_ALL_TUBE_REASON_NATURE_FAIL,
} from '../actions/tubeReason';
import { createReducer } from '@reduxjs/toolkit';
import { ErrorAction, errorHandler } from 'utils/error';

const initialState = {
	loading: false,
	untaken: [],
	added: [],
	nature: [],
};

const tubeReasons = createReducer(initialState, {
	/** GET ALL UNTAKEN  **/
	[API_GET_ALL_TUBE_REASON_UNTAKEN]: (state, action) => {
		state.loading = true;
	},
	[API_GET_ALL_TUBE_REASON_UNTAKEN_FAIL]: (state, action) => {
		errorHandler('Motif non prélèvement', ErrorAction.READ, action.error);
		state.loading = false;
	},
	[API_GET_ALL_TUBE_REASON_UNTAKEN_SUCCESS]: (state, action) => {
		state.loading = false;
		state.untaken = action.payload.data;
	},

	/** GET ALL ADDED  **/
	[API_GET_ALL_TUBE_REASON_ADDED]: (state, action) => {
		state.loading = true;
	},
	[API_GET_ALL_TUBE_REASON_ADDED_FAIL]: (state, action) => {
		errorHandler('Motif ajout tube', ErrorAction.READ, action.error);
		state.loading = false;
	},
	[API_GET_ALL_TUBE_REASON_ADDED_SUCCESS]: (state, action) => {
		state.loading = false;
		state.added = action.payload.data;
	},

	/** GET ALL NATURE  **/
	[API_GET_ALL_TUBE_REASON_NATURE]: (state, action) => {
		state.loading = true;
	},
	[API_GET_ALL_TUBE_REASON_NATURE_FAIL]: (state, action) => {
		errorHandler('Motif nature multiple', ErrorAction.READ, action.error);
		state.loading = false;
	},
	[API_GET_ALL_TUBE_REASON_NATURE_SUCCESS]: (state, action) => {
		state.loading = false;
		state.nature = action.payload.data;
	},
});

export default tubeReasons;
